<template>
  <div class="big_data">
    <!-- 背景 -->
    <!-- <canvas id="canvas" width="100%" height="100%"></canvas> -->
    <!-- <img class="BG_style" src="../assets/bg.jpg"   alt=""> -->
    <div class="home">
      <div class="background">
        <audio controls="controls" hidden ref="audio"></audio>
      </div>
      <div class="title">
        <img style="width:100%;height:1.8rem;" src="../assets/bg_1.png" alt />
        <img style="width:2rem;height:0.5rem;position: absolute;" src="../assets/bg_2.png" alt />
        <div
          class="title-style_1"
          style="position: absolute;display: flex;align-items: center;top: 10px;"
        >
          <img style="width:0.5rem;height:0.5rem;margin-right:10px" src="../assets/logo.png" alt />
          <div class="title_text">橘色盒子云数据中心</div>
        </div>
        <img class="title_xian" src="../assets/bg_7.png" alt />
        <img class="title_xian_right" src="../assets/bg_7.png" alt />
        <img class="title_left" src="../assets/bg_8.png" alt />   
        <img class="title_left1" src="../assets/bg_8.png" alt />

        <!-- <img  class="Img_assetc" style="position: absolute;left:20%,top:10%" src="../assets/map.png" alt /> -->


      </div>
      <div class="part">
        <div class="left-box">
          <!-- 热销商品 -->
          <ProductMoudle />
          <!-- 省份销售排行 -->
          <InstallMoudle />
        </div>
        <div class="mid-box">
          <!-- 访客成交额 -->
          <TrendMoudle />
          <!--  -->
          <img style="width:100%;height:150px;" src="../assets/bg_3.png" alt />
          <img class="mid-box_left" src="../assets/bg_4.png" alt />
          <img class="mid-box_right" src="../assets/bg_4.png" alt />
          <img class="mid-box_right1" src="../assets/bg_6.png" alt />
          <img class="mid-box_left1" src="../assets/bg_6.png" alt />
          <img class="mid-box_bg" src="../assets/bg_9.png" alt />
          <!-- 地图 -->
          <MapMoudle :province="tipsProvince" />
          <!-- 底部 -->
          <div class="footer">
            <div class="bottom_tit">合伙人的成功就是我们的成功</div>
            <p class="bottom_P">400-023-0001</p>
          </div>
        </div>
        <div class="right-box">
          <!-- 年龄画像 -->
          <OrderMoudle />
          <!-- 省份销售排行 -->
          <CitySaleMoudle />
        </div>
      </div>
    </div>
    <img class="title_bottom" src="https://easyv.assets.dtstack.com/data/img/11770/65518/9JUge2YGz_1604463856985_7Wnor-Hgr6.png" alt />
  </div>
  
</template>

<script>
import ProductMoudle from "./moudles/ProductMoudle";
import OrderMoudle from "./moudles/OrderMoudle";
import InstallMoudle from "./moudles/InstallMoudle";
import CitySaleMoudle from "./moudles/CitySaleMoudle";
import TrendMoudle from "./moudles/TrendMoudle";
import ProductListMoudle from "./moudles/ProductListMoudle";
import MapMoudle from "./moudles/MapMoudle";

let webDatas = { c: "heartbeat", a: "index" }; //心跳
var connect = 0;
export default {
  data() {
    return {
      websock: {}, //websock
      notifyPromise: Promise.resolve(), //解决消息通知重叠
      audio_url: require("../../static/mp3/1.mp3"), //提示音 mp3
      tipsProvince: "" //通知消息的定位
    };
  },
  components: {
    ProductMoudle,
    OrderMoudle,
    InstallMoudle,
    CitySaleMoudle,
    TrendMoudle,
    ProductListMoudle,
    MapMoudle
  },
  mounted() {
    this.__initWebSocket();
    // this.allStarShow();
  },

  methods: {
    // 创建WebSocket
    __initWebSocket() {
      const wsuri = "ws://data_admin.jusehezi.com:9655"; //线上
      //   const wsuri = "ws://39.108.52.186:9655"; //线下
      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.onopensss;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    // 连接websocket
    onopensss(e) {
      console.log(e, "eeeeeeeeeeeeeeeeeeeee");
      var sendData = {};
      //初始化
      sendData = JSON.stringify(webDatas);
      if (this.websock.readyState == 1) {
        this.websock.send(sendData); //第一次进来先执行一次
      }
    },
    //发送数据包
    threadPoxi() {
      //sendData
      const agentData = this.$route.query.token; //参数
      //若是ws开启状态
      if (this.websock.readyState === this.websock.OPEN) {
        this.websocketsend(agentData);
      }
      // 若是 正在开启状态，则等待300毫秒
      else if (this.websock.readyState === this.websock.CONNECTING) {
        setTimeout(() => {
          this.websocketsend(agentData);
        }, 300);
      } else {
        // 若未开启 ，则等待500毫秒 console.log('挂了重连')，重连超过20次，关闭连接
        connect++;
        console.log("connect", connect);
        if (connect > 20) {
          return;
        }
        this.__initWebSocket();
        setTimeout(() => {
          this.websocketsend(agentData);
        }, 500);
      }
    },
    //数据发送
    websocketsend(agentData) {
      clearInterval(interval); //先清一次心跳
      var interval = setInterval(() => {
        //此处循环
        var sendData = {};
        sendData = JSON.stringify(webDatas);
        if (this.websock.readyState == 1) {
          this.websock.send(sendData); //第一次景来先执行一次
        }
      }, 30000);
    },
    //关闭监听
    websocketclose(e) {
      this.websock.close();
      this.threadPoxi(); //重连  // console.log("哦豁 我挂掉了");
    },
    // 接收数据
    async websocketonmessage(e) {
      console.log(e, "接收数据");
      var redata = JSON.parse(e.data) || "";
      console.log(redata, "redata===================");
      if (redata == "") {
        return;
      }
      var command = redata.command;
      var data_main = redata.data;
      switch (command) {
        case "A0":
          // 通知消息
          this.dealMessage(
            data_main.type,
            data_main.notice,
            data_main.province
          );

          break;
        case "A5":
          // 省份销售排行----象形柱图
          this.$store.dispatch("updateCommit", {
            name: "cityShopData",
            data: data_main
          });
          break;
        case "A9":
          this.$store.dispatch("updateCommit", {
            name: "productData",
            data: data_main
          });
          break;
        case "A11":
          // 省份销售排行----象形柱图
          this.$store.dispatch("updateCommit", {
            name: "citySaleData",
            data: data_main
          });
          break;
        case "A12":
          // 非图表类信息
          this.$store.dispatch("updateCommit", {
            name: "otherData",
            data: data_main
          });
          break;
        case "A13":
          // 手机类型
          this.$store.dispatch("updateCommit", {
            name: "phoneData",
            data: data_main
          });
          break;
        case "A14":
          // 实时订单
          this.$store.dispatch("updateCommit", {
            name: "timeData",
            data: data_main
          });
          break;
        case "A15":
          // 散点
          this.$store.dispatch("updateCommit", {
            name: "sanData",
            data: data_main
          });
          break;
        case "A16":
          // 飞线
          this.$store.dispatch("updateCommit", {
            name: "feiData",
            data: data_main
          });
      }
    },
    // 处理通知消息
    dealMessage(type, notice, province) {
      if (type == 4) return;
      const iconClass = {
        1: "mains1",
        3: "mains3",
        6: "mains6",
        7: "mains7"
      };
      // 图标对象
      const iconObj = {
        1: "el-icon-s-order", //用户下单--type=1
        3: "el-icon-s-grid", // 设备相关--上线，安装 type =2,3
        4: "el-icon-s-shop", //商户入驻 type=4
        6: "el-icon-s-custom", // 代理商入驻 type=6
        7: "el-icon-message-solid", // 用户相关--上线 ,新用户 type =7,5
        default: "el-icon-message-solid" //默认
      };
      let icon_type = (() => {
        if ([5, 7].includes(type)) return 7;
        else if ([2, 3].includes(type)) return 3;
        else return type;
      })();
      let position_type = (() => {
        if ([1, 5, 7].includes(type)) return 1;
        else if ([2, 3, 4, 6].includes(type)) return 2;
      })();
      if ([2, 3, 4].includes(type)) {
        this.tipsProvince = province;
      }
      this.notifyPromise = this.notifyPromise
        .then(this.$nextTick)
        .then(async () => {
          await this.$notify({
            dangerouslyUseHTMLString: true,
            message:
              '<span class="' +
              iconClass[icon_type] +
              '">' +
              notice +
              "</span>",
            center: true,
            iconClass: iconObj[icon_type || "default"],
            customClass: iconClass[icon_type],
            position: position_type == 1 ? "top-left" : "top-right",
            duration: 6000
          });
          let audio = this.$refs.audio;
          audio.src = this.audio_url;
          await audio
            .play()
            .then(() => {
              setTimeout(() => {}, audio.duration * 1000); // audio.duration 为音频的时长单位为秒
            })
            .catch(e => {
              console.log("加载失败");
            });
        });
    },
    // 背景 --- 全星
    allStarShow() {
      var canvas = document.getElementById("canvas"),
        ctx = canvas.getContext("2d"),
        w = (canvas.width = window.innerWidth),
        h = (canvas.height = window.innerHeight),
        hue = 217,
        stars = [],
        count = 0,
        maxStars = 1200;
      var canvas2 = document.createElement("canvas"),
        ctx2 = canvas2.getContext("2d");
      canvas2.width = 100;
      canvas2.height = 100;
      var half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
      gradient2.addColorStop(0.025, "#fff");
      gradient2.addColorStop(0.1, "hsl(" + hue + ", 61%, 33%)");
      gradient2.addColorStop(0.25, "hsl(" + hue + ", 64%, 6%)");
      gradient2.addColorStop(1, "transparent");
      ctx2.fillStyle = gradient2;
      ctx2.beginPath();
      ctx2.arc(half, half, half, 0, Math.PI * 2);
      ctx2.fill();
      // End cache
      function random(min, max) {
        if (arguments.length < 2) {
          max = min;
          min = 0;
        }

        if (min > max) {
          var hold = max;
          max = min;
          min = hold;
        }

        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function maxOrbit(x, y) {
        var max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max));
        return diameter / 2;
      }
      var Star = function() {
        this.orbitRadius = random(maxOrbit(w, h));
        this.radius = random(60, this.orbitRadius) / 12;
        this.orbitX = w / 2;
        this.orbitY = h / 2;
        this.timePassed = random(0, maxStars);
        this.speed = random(this.orbitRadius) / 900000;
        this.alpha = random(2, 10) / 10;
        count++;
        stars[count] = this;
      };

      Star.prototype.draw = function() {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
          y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
          twinkle = random(10);

        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05;
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }

        ctx.globalAlpha = this.alpha;
        ctx.drawImage(
          canvas2,
          x - this.radius / 2,
          y - this.radius / 2,
          this.radius,
          this.radius
        );
        this.timePassed += this.speed;
      };
      for (var i = 0; i < maxStars; i++) {
        new Star();
      }

      function animation() {
        ctx.globalCompositeOperation = "source-over";
        ctx.globalAlpha = 0.9;
        ctx.fillStyle = "hsla(" + hue + ", 64%, 6%, 1)";
        ctx.fillRect(0, 0, w, h);

        ctx.globalCompositeOperation = "lighter";
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw();
        }

        window.requestAnimationFrame(animation);
      }
      animation();
    }
  }
};
</script>

<style>

body{
  width:100%;
  height:100%;
  background:url('../assets/bg.jpg');
  background-repeat: no-repeat;
  background-size:100% 100%;
  background-attachment:fixed;
}

/* .BG_style{
position: fixed;


} */
.title_bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  
}
.mid-top-num {

 
}
.title_left1{
   width: 6.5rem;
  height: 1rem;
  position: absolute;
  right: 20px;
  top: 0px;
  transform: perspective(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(-1) scaleY(1) translate3d(0px, 0px, 0px);

}
.title_left{
  width: 6.5rem;
  height: 1rem;
  position: absolute;
  left: 20px;
  top: 0px;
}
.title_xian_right {
 width: 7.5rem;
  height:1.2rem;
  position: absolute;
  right: 2.1rem;
  top: -0.08rem;
  transform: perspective(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(-1) scaleY(1) translate3d(0px, 0px, 0px);
}
.title_xian {
  width: 7.5rem;
  height:1.2rem;
  position: absolute;
  left: 2.1rem;
  top: -0.08rem;
}
.mid-box_left {
  width: 0.3rem;
  height: 1.6rem;
  position: absolute;
  left: 5.25rem;
  top: 0.8rem;
}
.mid-box_bg{
  width: 5rem;
  height: 9rem;
  top: 1.5rem;
  position: absolute;
  left: 9.7rem;
}
.mid-box_left1 {
  width: 50px;
  height: 0.6rem;
  top: 1.3rem;
  position: absolute;
  left: 5.35rem;

}
.mid-box_right1 {
  width: 50px;
  height: 60px;
  position: absolute;
  top: 1.3rem;
  right: 5.35rem;
  transform: perspective(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    scaleX(-1) scaleY(1) translate3d(0px, 0px, 0px);
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 3s;
    animation-delay: 0s;

}
.mid-box_right {
  width: 0.3rem;
  height: 1.6rem;
  position: absolute;
  top: 0.8rem;
  right: 5.25rem;
  transform: perspective(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    scaleX(-1) scaleY(1) translate3d(0px, 0px, 0px);
}
.title_text {
  /* width: 1088px; */
  font-family: 优设标题黑;
  font-size: 0.34rem;
  font-weight: normal;
  text-align: center;
  letter-spacing: 20px;
  text-shadow: rgba(103, 140, 235, 0.6) 0px 0px 24px;
  -webkit-box-reflect: below -4px linear-gradient(transparent, rgba(0, 0, 0, 0));
}
/* 主题背景色 #000218 */
#canvas {
  background-image: -webkit-radial-gradient(
    ellipse farthest-corner at center top,
    #000219 0%,
    #000219 100%
  );
  background-image: radial-gradient(
    ellipse farthest-corner at center top,
    #000219 0%,
    #000219 100%
  );
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.home {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.16rem;
  color: #fff;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 0.2rem 0 0.1rem; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
/* 标题左右边框 */
.title-before {
  display: inline-block;
  width: 28%;
  height: 0.3rem;
  position: relative;
}
.title-after {
  transform: rotateZ(180deg) rotateX(180deg);
}
.title-circle-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 30%;
  left: 2%;
  transform: translateY(-50%);
}
.title-circle {
  display: inline-block;
  width: 0.04rem;
  height: 0.06rem;
  background: #0da0ee;
  border-radius: 50%;
  margin: 0 1px;
}
.title-circle:nth-of-type(1) {
  background: #064c7d;
}
.title-circle:nth-of-type(2) {
  background: #085e95;
}
.title-circle:nth-of-type(3) {
  background: #0da0ee;
}
.title-circle:nth-of-type(4) {
  background: #0eadff;
}
.title-circle:nth-of-type(5) {
  background: #096ba6;
}
.title-circle:nth-of-type(6) {
  background: #064c7d;
}
.title-block-box {
  display: inline-block;
  height: 0.2rem;
  position: absolute;
  top: 0;
  right: 2%;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transform: skew(15deg);
}
.title-block-box::after {
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to right, rgba(0, 2, 25, 1), rgba(0, 2, 25, 0.3));
  box-shadow: 0 0 30px rgba(0, 2, 25, 1);
  border-radius: 50%;
  transform: translateX(-20%) translateY(-50%);
}
@keyframes title-block {
  0% {
    transform: translateX(-40%) translateY(-20%);
  }
  30% {
    transform: translateX(220%) translateY(-20%);
  }
  100% {
    transform: translateX(220%) translateY(-20%);
  }
}
.title-block-one {
  display: inline-block;
  width: 0.05rem;
  height: 100%;
  margin-left: 2px;
  background: #0eadff;
}
.title-before-border1 {
  display: inline-block;
  width: 80%;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(12, 150, 224, 0.2),
    rgba(12, 150, 224, 1),
    rgba(12, 150, 224, 0)
  );
  position: absolute;
  bottom: 40%;
  left: -5%;
}
.title-before-border2 {
  display: inline-block;
  width: 70%;
  height: 2px;
  background: linear-gradient(
    to right,
    rgba(12, 150, 224, 0),
    #0da2f1 65%,
    #0da3f1 100%
  );
  position: absolute;
  bottom: 0;
  right: -0.05rem;
}
.title-before-border2::after {
  content: "";
  width: 2px;
  height: 0.3rem;
  background: #0da0ee;
  position: absolute;
  top: 0;
  right: 0.04rem;
  transform: translateY(-100%) skew(15deg);
}
/* 标题左右边框  end*/
/* 标题样式 */
.title-style {
  text-align: center;
  font-size: 0.36rem;
  position: relative;
  min-width: 4rem;
  padding: 0.1rem 0.6rem;
  margin: 0 0.1rem;
  color: #ffffff;
  box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  letter-spacing: 0.08rem;
  position: relative;
  overflow: hidden;
  z-index: 10;
  display: flex;
  align-items: center;
}
@-webkit-keyframes masked-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@keyframes title_anim {
  0% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
  10% {
    box-shadow: 0 0 15px 0 #0efcff inset, 0 0 30px 0 #0efcff inset;
  }
  20% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
  100% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
}
.title-style::before {
  content: "";
  width: 0.25rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  left: 0;
  transform: skew(15deg) translateX(-50%);
  box-shadow: 0 0 5px 0 #5ab7fc, 0 0 15px 0 #4893cb;
}
.title-style::after {
  content: "";
  width: 0.25rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  right: 0;
  transform: skew(-15deg) translateX(50%);
  box-shadow: 0 0 5px 0 #5ab7fc, 0 0 15px 0 #4893cb;
}
.title-border1 {
  width: 80%;
  height: 0.05rem;
  /* background: #000219; */
  background: #000219;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 5px 0 #4893cb;
}
.title-border1::before {
  content: "";
  width: 0.05rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  left: 0;
  transform: skew(-20deg);
  box-shadow: -5px 0 5px 0 #4893cb;
}
.title-border1::after {
  content: "";
  width: 0.05rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  right: -1%;
  transform: skew(20deg);
  box-shadow: 5px 0 5px 0 #4893cb;
}
.title-border2 {
  width: 70%;
  height: 0.02rem;
  background: #0d9eea;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
/* 标题样式 end */

.part {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.2rem 0.3rem 0;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
}

/* 左右部分 */
.left-box {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.right-box {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
/* 左右部分 end */
/* 中间部分 */
.mid-box {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* padding: 0 0.2rem; */
  box-sizing: border-box;
}
/* 中间部分 end */

/* 消息框样式颜色 */
.mains1 {
  color: #fffc00 !important;
}

.mains3 {
  color: #ffffff !important;
}

.mains6 {
  color: #66d804 !important;
}

.mains7 {
  color: #ff9302 !important;
}
.bottom_tit {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-shadow: 1px 1px 3px #678ceb;
  font-weight: normal;
  font-size: 0.32rem;
    font-weight: bold;
    text-transform: uppercase;
	text-shadow: #79284b 1px 4px ;
    padding-left: 0.22rem;
    padding-bottom: 0.2rem;
    letter-spacing: 0.1rem;
}
.bottom_P {

  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-shadow: 1px 1px 3px #678ceb;
  font-weight: normal;
  font-size: 0.22rem;
    font-weight: bold;
    text-transform: uppercase;
	text-shadow: #79284b 1px 4px ;
  letter-spacing: 0.07rem;


}
.footer {
  position: absolute;
  bottom: 1.5%;
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue